import i18n from "i18next" 
import { initReactI18next } from "react-i18next" 
import translationEN from "./locales/en.json"
import translationFR from "./locales/fr.json"

const savedLanguage = localStorage.getItem('language');

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: translationEN },
    fr: { translation: translationFR }
  },
  lng: savedLanguage ? savedLanguage.toLowerCase() : 'fr',
  fallbackLng: 'fr',
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: true
  }
});


export default i18n;